<div class="col-12 text-2xl font-bold">
    {{ title }}
</div>